module.exports = __webpack_public_path__ + "static/media/nethermind-circle.fbbf1a32.png";